export default "Slip kreativiteten løs og lav en hel rudel af smukke krondyr af pap og pinde!";